import { useEffect } from 'react';
import { useInterval } from './useInterval';
import _ from 'lodash';

type UsePollingOptions = {
	pollingInterval?: number;
	idleTimeout?: number;
	callback: () => void;
};

const DEFAULT_POLLING_INTERVAL = 60000;

export default function usePolling({
	pollingInterval = DEFAULT_POLLING_INTERVAL,
	callback,
}: UsePollingOptions) {
	const delay = _.random(
		pollingInterval,
		pollingInterval + pollingInterval * 0.02
	);
	const interval = useInterval(callback, delay);

	useEffect(() => {
		interval.start();
		return interval.stop;
	}, []);
}
